export const RoleInUserTypes = {
  SuperAdmin: ["ahmetk@gmail.com", "ali@ali.com", "kabakabaci@gmail.com"],
  Admin: ["SuperAdmin", "Admin"],
  Organizer: ["SuperAdmin", "Admin", "Organizer"],
  User: ["SuperAdmin", "Admin", "Organizer", "User"],
};
